import { useQuery } from '@tanstack/react-query';
import { CaseStudyService } from '@/services/caseStudies';

// Hook for fetching case studies
// By default, only fetches published case studies for public consumption
export function useCaseStudies(profileId?: string, status: 'draft' | 'published' = 'published') {
  return useQuery({
    queryKey: ['case-studies', profileId, status],
    queryFn: () => CaseStudyService.listCaseStudies(profileId, status),
    enabled: !!profileId,
    staleTime: 5 * 60 * 1000, // Cache for 5 minutes
  });
}

// Hook for fetching a single case study by ID
export function useCaseStudyById(id: string) {
  return useQuery({
    queryKey: ['case-study', id],
    queryFn: () => CaseStudyService.getCaseStudy(id),
    enabled: !!id,
  });
}

// Hook for fetching a single case study by slug
export function useCaseStudyBySlug(slug: string) {
  return useQuery({
    queryKey: ['case-study-by-slug', slug],
    queryFn: () => CaseStudyService.getCaseStudyBySlug(slug),
    enabled: !!slug,
  });
}
